import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { VendorService } from '../vendor.service'
import { ToastrService } from 'ngx-toastr'
import { ActivatedRoute, Router } from '@angular/router'
import { MasterCommonServices } from '../../quotation/master.common.service'
import { VendorMemberService } from '../../member-vendor/member-vendor.service'
import { FormsModule } from '@angular/forms'
import { VendorMemberModel } from '../../member-vendor/member-vendor.model'

@Component({
  selector: 'app-vendor-master',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatProgressBarModule, FormsModule],
  templateUrl: './add-vendor.component.html',
  styleUrls: ['./add-vendor.component.css'],
})
export class AddVendorComponent implements OnInit {
  addVendorForm: FormGroup = new FormGroup({})
  isLoading: boolean = false
  submitted: boolean = false
  mode: string = 'add'
  vendorData: any
  isSubmitDisabled: boolean = false
  vendorMembers: any[] = []
  expandedVendorMembers: { [key: number]: boolean } = {}
  vendorMemberSubmitted: boolean = false


constructor(
  private formBuilder: FormBuilder,
  private vendorService: VendorService,
  private toastr: ToastrService,
  private router: Router,
  public masterCommonService: MasterCommonServices,
  private vendorMemberService: VendorMemberService,
) {
  this.initializeForm()

  const navigation = this.router.getCurrentNavigation()

  if (navigation?.extras.state) {
    const state = navigation.extras.state

    this.mode = state['mode'] || 'add'

    if (this.mode === 'update' || this.mode === 'view') {
      this.vendorData = state['vendor']
      console.log(this.vendorData);
      
      this.addVendorForm.patchValue({
        id: this.vendorData.id,
        vendorName: this.vendorData.vendorName,
        gstNo: this.vendorData.gstNo,
        address: this.vendorData.address,
        contactNo: this.vendorData.contactNo,
        bankName: this.vendorData.bankName,
        bankAccountNo: this.vendorData.bankAccountNo,
        bankIfscCode: this.vendorData.bankIfscCode,
        bankBranchName: this.vendorData.bankBranchName,
        addedOn: this.vendorData.addedOn,
        modifiedOn: this.vendorData.modifiedOn,
      })

      this.addVendorForm.markAsPristine()
      this.isSubmitDisabled = true

      this.loadVendorMembersForVendor(this.vendorData.id)
    }
  }
}

 ngOnInit(): void {
  this.addVendorForm.statusChanges.subscribe(() => {
    this.updateSubmitButtonState()
  })
}

  updateSubmitButtonState(): void {
    // Disable submit button if form is pristine (not modified)
    this.isSubmitDisabled = this.addVendorForm.pristine
  }

  initializeForm() {
    this.addVendorForm = this.formBuilder.group({
      id: [null],
      vendorName: ['', Validators.required],
      gstNo: ['', Validators.required],
      address: ['', Validators.required],
      contactNo: ['', Validators.required],
      bankName: ['', Validators.required],
      bankAccountNo: ['', Validators.required],
      bankIfscCode: ['', Validators.required],
      bankBranchName: ['', Validators.required],
      addedOn: [''],
      modifiedOn: [''],
    })
  }

  submit() {
    this.submitted = true
    if (this.addVendorForm.invalid) {
      return
    }
    this.isLoading = true
    let payload = this.addVendorForm.value
    payload['modifiedOn'] = new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000,
    ).toISOString()
    if (this.mode === 'update') {
      this.vendorService.updateVendor(payload).subscribe({
        next: (response: any) => {
          this.isLoading = false
          this.toastr.success(
            'Vendor Updated Successfully!!',
            'Updation Successful',
          )
          this.masterCommonService.getAllVendors()
          // Mark form as pristine and disable submit button
          this.addVendorForm.markAsPristine()
          this.isSubmitDisabled = true
          this.submitted = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    } else {
      payload['addedOn'] = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      ).toISOString()
      this.vendorService.addVendor(payload).subscribe({
        next: (response: any) => {
          this.isLoading = false
          this.masterCommonService.getAllVendors()
          this.toastr.success(
            'Vendor Added Successfully!!',
            'Creation Successful',
          )
          // Change mode to edit, populate ID, and disable submit button
          this.mode = 'update'
          this.addVendorForm.patchValue({
            id: response?.id,
            addedOn: response?.addedOn
          })
          this.addVendorForm.markAsPristine()
          this.isSubmitDisabled = true
          this.submitted = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    }
  }

  addVendorMember(): void {
  const newMember = {
    id: null,
    vendorId: this.addVendorForm.get('id')?.value,
    memberName: '',
    email: '',
    mobile: '',
    isWhatsApp: false,
    skypeId: '',
    telephone: '',
    designation: '',
    isMainSeller: false,
    pmoc: null,
    addedOn: null,
    modifiedOn: null,
    isNew: true,
    isEditing: true,
  }

  this.vendorMembers.push(newMember)
  this.expandedVendorMembers[this.vendorMembers.length - 1] = true
}

toggleVendorMemberExpanded(index: number): void {
  this.expandedVendorMembers[index] =
    !this.expandedVendorMembers[index]
}

editVendorMember(member: any): void {
  member.isEditing = true
  this.expandedVendorMembers[this.vendorMembers.indexOf(member)] = true
}

cancelVendorMember(index: number, member: any): void {
  if (member.isNew) {
    this.vendorMembers.splice(index, 1)
    delete this.expandedVendorMembers[index]
  } else {
    member.isEditing = false
    this.vendorMemberSubmitted = false
  }
}

deleteVendorMember(index: number, member: any): void {
  if (confirm('Are you sure you want to delete this member?')) {

    this.isLoading = true

    this.vendorMemberService.deleteVendorMember(member).subscribe({
      next: () => {

        this.isLoading = false

        this.vendorMembers.splice(index, 1)
        delete this.expandedVendorMembers[index]

        this.toastr.success(
          'Vendor Member Deleted Successfully!',
          'Success'
        )
      },
      error: (error: any) => {

        this.isLoading = false

        this.toastr.error(
          error.statusText || 'Error deleting vendor member',
          'Error',
          {
            timeOut: 15000,
            closeButton: true,
            progressBar: true,
          }
        )
      },
    })
  }
}

saveMember(member: any): void {
  this.vendorMemberSubmitted = true

  // Required validation
  if (
    !member.memberName ||
    !member.email ||
    !member.mobile
  ) {
    this.toastr.error(
      'Please fill all required fields',
      'Validation Error'
    )
    return
  }

  // Email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  if (!emailRegex.test(member.email)) {
    this.toastr.error(
      'Please enter a valid email',
      'Validation Error'
    )
    return
  }

  this.isLoading = true

  // ADD NEW MEMBER
  if (member.isNew) {

    member.addedOn = new Date(
      new Date().getTime() -
        new Date().getTimezoneOffset() * 60000
    ).toISOString()

    this.vendorMemberService.addVendorMember(member).subscribe({
      next: (response: any) => {

        this.isLoading = false

        member.id = response?.id
        member.isNew = false
        member.isEditing = false

        this.vendorMemberSubmitted = false

        this.toastr.success(
          'Vendor Member Added Successfully!',
          'Success'
        )
      },

      error: (error: any) => {

        this.isLoading = false

        this.toastr.error(
          error.statusText || 'Error adding vendor member',
          'Error',
          {
            timeOut: 15000,
            closeButton: true,
            progressBar: true,
          }
        )
      },
    })

  } else {

    // UPDATE MEMBER
    member.modifiedOn = new Date(
      new Date().getTime() -
        new Date().getTimezoneOffset() * 60000
    ).toISOString()

    this.vendorMemberService.updateVendorMember(member).subscribe({
      next: () => {

        this.isLoading = false

        member.isEditing = false
        this.vendorMemberSubmitted = false

        this.toastr.success(
          'Vendor Member Updated Successfully!',
          'Success'
        )
      },

      error: (error: any) => {

        this.isLoading = false

        this.toastr.error(
          error.statusText || 'Error updating vendor member',
          'Error',
          {
            timeOut: 15000,
            closeButton: true,
            progressBar: true,
          }
        )
      },
    })
  }
}

  loadVendorMembersForVendor(vendorId: number): void {
  this.vendorMemberService.getAllVendorMembers().subscribe({
    next: (allVendorMembers: any[]) => {

      this.vendorMembers = allVendorMembers.filter(
        (m) => m.vendorId === vendorId
      )

      this.vendorMembers.forEach((_, index) => {
        this.expandedVendorMembers[index] = false
      })
    },
    error: (error: any) => {
      console.error('Error loading vendor members:', error)
    },
  })
}
}
